<template>
  <div class=" w-full rounded-lg">
    <div class="flex justify-center items-center flex-col">
      <h1 class="text-center">CULTIV</h1>
      <hr class="md:w-1/3 w-1/2 mt-5 rounded-lg border-1 mb-5 border-cv">
    </div>

    <div class="flex md:flex-row flex-col md:p-2 shadow-lg rounded-lg gap-2">
      <div class="mb-4 md:mb-0">
        <h1 class="font-bold text-4xl mb-4">Animations des réseaux sociaux</h1>
        <ul>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Créations de contenus</li>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Shootings photos</li>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Montages vidéos</li>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Élaborations des plannings de posts (Instagram | Tiktoks)</li>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Modérations</li>
        </ul>

        <div class="flex flex-row items-center mt-5">
          <p><span class="font-bold">Logiciels mobilisés :</span></p>
          <img class="h-10 ml-2 p-2 hover:bg-gray-300 rounded-lg" src="@/assets/tic-tac.png" alt="tictac">
          <p>|</p>
          <img class="h-10 p-2 hover:bg-gray-300 rounded-lg" src="@/assets/instagram.png" alt="instagram">
          <p>|</p>
          <img class="h-10 p-2 hover:bg-gray-300 rounded-lg" src="@/assets/capcut.png" alt="capcut">
        </div>

        <!-- Media Grid -->
        <div class="relative w-full flex flex-col gap-2 mt-4">
          <div class="media-grid" :class="{ collapsed: !showAll }">
            <div
              v-for="(item, index) in allItems"
              :key="index"
              class="media-item-wrapper"
            >
              <video
                v-if="item.type === 'video'"
                class="media-item"
                controls
                playsinline
              >
                <source :src="item.src" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <img
                v-else
                :src="item.src"
                alt=""
                class="media-item"
              />
            </div>
          </div>

          <!-- Overlay with gradient if not expanded -->
          <div v-if="!showAll" class="fade-overlay"></div>

          <!-- Voir plus button -->
          <button
            v-if="!showAll"
            class="mt-4 mx-auto px-4 py-2 rounded-lg bg-cv text-white hover:bg-opacity-80 transition"
            @click="showAll = true"
          >
            Voir plus
          </button>
        </div>
      </div>
    </div>

    <!-- GESTIONS TIKTOKSHOP -->
    <div class="flex md:flex-row flex-col md:p-2 mt-12 shadow-lg rounded-lg gap-2">
      <div class="mb-4 md:mb-0">
        <h1 class="font-bold text-4xl mb-4">Gestions de Tiktok Shops</h1>
        <ul>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Lancements de campagnes UGC</li>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Veilles influences</li>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Prises de contacts</li>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Envois de colis</li>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Suivis des statistiques Tiktok Shops </li>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Bilans des opérations</li>
        </ul>

        <div class="flex flex-row items-center mt-5">
          <p><span class="font-bold">Logiciels mobilisés :</span></p>
          <img class="h-10 ml-2 p-2 hover:bg-gray-300 rounded-lg" src="@/assets/tic-tac.png" alt="tictac">
        </div>
      </div>
    </div>

    <!-- GESTIONS DES ADS -->
    <div class="flex md:flex-row flex-col md:p-2 mt-12 shadow-lg rounded-lg gap-2">
      <div class="mb-4 md:mb-0">
        <h1 class="font-bold text-4xl mb-4">Influences et Partenariats</h1>
        <ul>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Veilles</li>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Prises de contacts</li>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Suivis avec les influenceuses</li>
          <li><span class="ml-7 mr-3 text-2xl text-cv">•</span>Échanges téléphoniques avec les marques</li>
        </ul>

        <div class="flex flex-row items-center mt-5">
          <p><span class="font-bold">Logiciels mobilisés :</span></p>
          <img class="h-10 ml-2 p-2 hover:bg-gray-300 rounded-lg" src="@/assets/instagram.png" alt="tictac">
          <!-- excel -->
          <!-- mail -->
        </div>
      </div>
    </div>
  </div>
</template>


  
  <script setup>
  import { ref } from 'vue'
  
  import videoSrc from '@/assets/video/video1.mp4'
  import videoSrc2 from '@/assets/video/video2.mp4'
  import videoSrc3 from '@/assets/video/video3.mp4'
  import videoSrc4 from '@/assets/video/video4.mp4'
  import videoSrc5 from '@/assets/video/video5.mp4'
  import videoSrc6 from '@/assets/video/video6.mp4'
  
  import img1 from '@/assets/cultiv_1.jpg'
  import img2 from '@/assets/cultiv_2.jpg'
  import img3 from '@/assets/cultiv_3.jpg'
  import img4 from '@/assets/cultiv_4.jpg'
  import img5 from '@/assets/cultiv_5.jpg'
  import img6 from '@/assets/cultiv_6.jpg'
  import img7 from '@/assets/cultiv_7.jpg'
  import img8 from '@/assets/cultiv_8.jpg'
  import img9 from '@/assets/cultiv_9.jpg'
  import img10 from '@/assets/cultiv_10.jpg'
  import img11 from '@/assets/cultiv_11.jpg'
  import img13 from '@/assets/cultiv_13.jpg'
  import img15 from '@/assets/cultiv_15.jpg'
  import img16 from '@/assets/cultiv_16.jpg'
  import img17 from '@/assets/cultiv_17.jpg'
  import img18 from '@/assets/cultiv_18.jpg'
  import img19 from '@/assets/cultiv_19.jpg'
  import img20 from '@/assets/cultiv_20.jpg'
  import img21 from '@/assets/cultiv_21.jpg'
  import img22 from '@/assets/cultiv_22.jpg'
  import img23 from '@/assets/cultiv_23.jpg'
  
  const showAll = ref(false)
  
  const allItems = [
    { type: 'img', src: img1 },
    { type: 'img', src: img11 },
    { type: 'img', src: img17 },
    { type: 'img', src: img16 },
    { type: 'video', src: videoSrc3 },
    { type: 'video', src: videoSrc2 },
    { type: 'img', src: img8 },
    { type: 'img', src: img9 },
    { type: 'img', src: img13 },
    { type: 'img', src: img22 },
    { type: 'img', src: img5 },
    { type: 'video', src: videoSrc5 },
    { type: 'img', src: img10 },
    { type: 'img', src: img6 },
    { type: 'video', src: videoSrc4 },
    { type: 'img', src: img2 },
    { type: 'img', src: img3 },
    { type: 'img', src: img4 },
    { type: 'img', src: img21 },
    { type: 'img', src: img7 },
    { type: 'img', src: img15 },
    { type: 'img', src: img19 },
    { type: 'img', src: img18 },
    { type: 'video', src: videoSrc6 },
    { type: 'img', src: img20 },
    { type: 'video', src: videoSrc },
    { type: 'img', src: img23 }
  ]
  </script>
  
  <style scoped>
  .media-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(48%, 1fr));
    gap: 0.5rem;
    transition: max-height 0.3s ease;
    overflow: hidden;
  }
  
  @media (min-width: 768px) {
    .media-grid {
      grid-template-columns: repeat(5, 1fr);
    }
  }
  
  .media-grid.collapsed {
    max-height: 420px; /* ≈ 2 lignes à 5 éléments par ligne */
    position: relative;
  }
  
  .media-item {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 0.5rem;
  }
  
  .fade-overlay {
    position: absolute;
    bottom: 60px;
    left: 0;
    right: 0;
    height: 100px;
    background: linear-gradient(to bottom, transparent, white);
    pointer-events: none;
    z-index: 10;
  }
  </style>
  